import React from 'react';
import ScheduleCalendarSection from './ScheduleCalendarSection';

export default function VehicleScheduleSection({ vehicleId, vehicleName = '', embedded = false }) {
  return (
    <ScheduleCalendarSection
      scheduleUrl={vehicleId ? `/vehicles/${vehicleId}/schedule/` : null}
      resourceName={vehicleName}
      entityLabel="vehicle"
      embedded={embedded}
      showDriver
      enabled={!!vehicleId}
    />
  );
}
